<div class="label-title">{{ label }}</div>
<div class="content">
  <ng-content></ng-content>
</div>
